// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import Countdown from '../vue/Countdown.vue';
import Calendar from '../vue/Calendar.vue';
import ListVideos from '../vue/ListVideos.vue';

class VueComponents {
    /**
     * CONSTRUCTOR
     */
    constructor() {
        VueComponents.initComponents();
    }

    static initComponents() {
        const customComponentContainer = document.querySelectorAll('.app-vue');
        customComponentContainer.forEach((item) => {
            // eslint-disable-next-line no-new
            new Vue({
                el: item,
                components: {
                    countdown: Countdown,
                    calendar: Calendar,
                    'list-videos': ListVideos,
                },
            });
        });
    }
}

export default VueComponents;
